export default __webpack_public_path__ + "static/media/universe3.f0b6c8a1.png";